import { create } from "zustand";

interface State {
    id: string;
    isDirty: boolean;
    isSubmitting: boolean;
    isSaveDisabled: boolean;
}

interface Actions {
    setSubmitting(isSubmitting: boolean): void;
    setDirty(isDirty: boolean): void;
    setSaveDisabled(isSaveDisabled: boolean): void;
    setId(id: string): void;
    setState(state: Partial<State>): void;
    reset(): void;
}

const initialState: State = {
    id: "",
    isDirty: false,
    isSubmitting: false,
    isSaveDisabled: false,
};

const useFormStatus = create<State & Actions>(set => ({
    id: "",
    isDirty: false,
    isSubmitting: false,
    isSaveDisabled: false,
    setDirty: isDirty => set({ isDirty }),
    setSubmitting: isSubmitting => set({ isSubmitting }),
    setSaveDisabled: isSaveDisabled => set({ isSaveDisabled }),
    setId: id => set({ id }),
    reset: () => set(initialState),
    setState: state => set(state),
}));

export default useFormStatus;
